import { base32 } from 'rfc4648';
import CryptoJS from 'crypto-js';

export function BigIntToBEInt64WordArray(n: bigint):  CryptoJS.lib.WordArray
{
  const ffffffff = (BigInt(2) << BigInt(31)) - BigInt(1);
  // I have no idea what I'm doing wrt endianness :/
  const wh = Number((n >> BigInt(32)) & ffffffff);
  const wl = Number(n & ffffffff);
  return CryptoJS.lib.WordArray.create([wh, wl]);
}

// https://github.com/google/google-authenticator/wiki/Key-Uri-Format
export function TotpUri(props: {
  issuer: string,
  account: string,
  secret: string,
}
): string
{
  const secretBytes = new TextEncoder().encode(props.secret);
  const base32secret = base32.stringify(secretBytes).replace(/=+$/, '');

  return `otpauth://totp/${encodeURIComponent(props.issuer + ':' + props.account)}` +
    `?secret=${base32secret}` +
    `&issuer=${encodeURIComponent(props.issuer)}` +
    `&algorithm=SHA1` +
    `&digits=6` +
    `&period=30`;
}

// RFC 6328, 6 digits, 30s period
export function TotpToken(props: {
  secret: string,
  now: Date
})
{
  const nowInitial = 0;
  const nowUnix = props.now.getTime() / 1000;
  // seconds per tick
  const X = 30;
  // CryptoJS will convert to utf8
  const K = props.secret;

  const Tnum = BigInt(Math.floor((nowUnix - nowInitial) / X));

  const T = BigIntToBEInt64WordArray(Tnum);

  // 40 chars of 20 byte HMAC
  // K is the key
  // T is the message
  const hexhmac = CryptoJS.HmacSHA1(T, K).toString();

  // last byte determines offset in bytes, *2 because hex digits string
  const offset = (parseInt(hexhmac.substring(38), 16) & 0xf);
  const hexOffset = offset * 2;

  // four bytes, 31 bits
  const b1 = parseInt(hexhmac.substring(hexOffset, hexOffset + 2), 16) & 0x7f;
  const b2 = parseInt(hexhmac.substring(hexOffset + 2, hexOffset + 2 + 2), 16) & 0xff;
  const b3 = parseInt(hexhmac.substring(hexOffset + 4, hexOffset + 4 + 2), 16) & 0xff;
  const b4 = parseInt(hexhmac.substring(hexOffset + 6, hexOffset + 6 + 2), 16) & 0xff;

  const val = (b1 << 24) + (b2 << 16) + (b3 << 8) + b4;

  const digits = String(val % 1000000).padStart(6, '0');

  return digits;
}